import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';

import classNames from 'classnames';
import styled from 'styled-components';

import { Button } from '../../element';

import { useTranslation } from '../../../i18n';

import { getServiceAnalytics } from '../../../entities/providers/selectors';

const Container = styled.div`
  display: flex;
  justify-content: flex-end;

  margin-bottom: 20px;
`;

export interface StepperNavProps {
  active: number;
  total: number;
  nextDisabled: boolean;

  onChange(value: number): void;
  handleNext?: () => void;
}

export const StepperNav: React.FC<StepperNavProps> = ({
  total,
  active,
  nextDisabled = false,
  onChange,
  handleNext,
}) => {
  const [t] = useTranslation('rates');

  const { payID } = useSelector(getServiceAnalytics);
  const isNextDisabled = nextDisabled || active === total - 1;

  const emit = (value: number) => onChange(value);

  const onNext = useCallback(() => {
    emit(active + 1);
  }, []);

  return (
    <Container>
      <Button type="primary" disabled={active === 0} onClick={() => emit(active - 1)}>
        {t('rates.nav.back')}
      </Button>
      <button
        type="button"
        id={payID}
        className={classNames('el-button el-button--primary', {
          'is-disabled': isNextDisabled,
        })}
        disabled={isNextDisabled}
        onClick={handleNext || onNext}
      >
        {t('rates.nav.next')}
      </button>
    </Container>
  );
};
